import { Flex, GroupOutlinedIcon, Text } from '@shared/components';

export default function QuestionReviewReviewerEmptyState() {
  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: theme.spacing(20),
        gap: theme.spacing(4),
      })}
    >
      <GroupOutlinedIcon
        sx={(theme) => ({
          width: 100,
          height: 100,
          color: theme.palette.grey[400],
        })}
      />
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          gap: theme.spacing(2),
          textAlign: 'center',
        })}
      >
        <Text variant='h3'>ยังไม่มีผู้ทบทวนข้อสอบ</Text>
        <Text>
          คลิก &quot;+ Add Reviewer&quot; เพื่อมอบหมายงานให้ผู้ทบทวน สามารถเพิ่มได้สูงสุด 3 คน
        </Text>
      </Flex>
    </Flex>
  );
}
